import React from 'react';
import classNames from 'classnames';

import SectionContainer from '../SectionContainer';
import css from './SectionHowItWorks.module.css';

const HOW_IT_WORKS_STEPS = [
  {
    number: '01',
    title: 'Поиск специалиста',
    body: 'Ищите специалистов на карте, фильтруйте по типу услуги, месту и рейтингу',
  },
  {
    number: '02',
    title: 'Переписка и встреча',
    body: 'Напишите специалисту и договоритесь о встрече или онлайн-консультации',
  },
  {
    number: '03',
    title: 'Результат',
    body: 'Получайте качественный сервис и экономьте время с проверенными специалистами в Европе',
  },
];

const SectionHowItWorks = props => {
  const { sectionId, className } = props;

  return (
    <SectionContainer id={sectionId} className={classNames(className, css.sectionDark)}>
      <div className={css.outer}>
        <div className="delowo-surface">
          <div className={css.intro}>
            <h2 className="delowo-text--section-title">Как работает DELOWO</h2>
            <p className={css.subtitle}>
              {'Найдите специалиста в\u00a0Европе и\u00a0договоритесь о\u00a0встрече'}
            </p>
          </div>
          <div className={css.stepsGrid}>
            {HOW_IT_WORKS_STEPS.map((step, index) => (
              <article
                key={step.number}
                className={classNames('delowo-card--step', css.stepCard, {
                  'delowo-card--step-active': index === 0,
                })}
              >
                <p className={classNames('delowo-text--step-number', css.stepNumber)}>
                  {step.number}
                </p>
                <div className={css.stepBottom}>
                  <div className={css.stepTitleBox}>
                    <h3 className="delowo-text--card-title">{step.title}</h3>
                  </div>
                  <p className="delowo-text--card-body">{step.body}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionHowItWorks;
